import l10n from '../l10n/localization';

export default {
    amount: {
        presence: {
            message: l10n.validation.required,
        },
    },
    label: {
        presence: {
            message: l10n.validation.required,
        },
    },
};



// WEBPACK FOOTER //
// ./src/validation/invoice.js